import React from "react";
import { HelpAndSupport } from "../../../components/admin/Dashboard/help/HelpAndSupport";
import PurpleBg from "../../../assets/images/purplebg.png";
import { ReactComponent as SupportMan } from "../../../assets/images/supportMan.svg";
import { Button } from "../../../components/common";
import { Insights } from "../../../components/admin/Dashboard/dashboard/Insights";

export const Help = () => {
  return (
    <>
      <div className="flex flex-col sm:grid grid-cols-10 gap-4 h-full ">
        <div className="w-full col-start-1 col-end-8 punitpaa">
          <HelpAndSupport />
        </div>
        <div className="w-full col-start-8 col-end-11 flex flex-col  ">
          <div className="relative max-h-96">
            <div className="relative">
              <img src={PurpleBg} alt="ticket" />
            </div>
            <div className=" absolute p-6 flex flex-col items-center justify-center top-0 w-full h-full text-f14 text-white">
              <SupportMan />
              <h4 className="text-f20 text-white my-2">Reach out to us at</h4>
              <span>info@trevex.io</span>
              <span>from 9 AM - 6 PM</span>
            </div>
            <div className="mt-4">
              <Insights notification_category={"support_ticket"}/>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
